
import { defineComponent } from 'vue';
import Calendar from '@/components/Calendar.vue';
import { Slot, CalendarDay } from '@/utils/interfaces';
import ListingCalendarSkeleton from '@/components/listing-calendar/ListingCalendarSkeleton.vue';
import { getDateFrom, mapCalendarSlots } from '@/utils/helpers';
import HTTP from '@/config/axios-instance';

interface IMechanicMeta {
  lat: string;
  lng: string;
  address: string;
  zilo_id: string;
}

interface IServiceMeta {
  name: string;
  description: string;
}

const bookowarkaURL = process.env.VUE_APP_BOOKOWARKA_URL || 'https://dobrymechanik.pl/umow';

export default defineComponent({
  name: 'ListingCalendarWidget',
  components: {
    Calendar,
    ListingCalendarSkeleton
  },
  $refs!: {
    listingCalendarForm: HTMLFormElement
  },
  props: {
    dataSharedSlots: {
      type: Boolean,
      default: false
    },
    dataMechanicId: {
      type: Number,
      default: 0
    },
    dataServiceUuid: {
      type: String,
      default: ''
    },
    dataSlotsInjected: {
      type: String,
      default: ''
    },
    dataSlotsInterval: {
      type: Number,
      default: 0
    },
    dataPricing: {
      type: Boolean,
      default: false
    },
    dataServiceCategoryUuid: {
      type: String,
      default: ''
    },
    dataNonMaster: {
      type: String,
      default: ''
    },
    dataShowOtherForm: {
      type: String,
      default: 'true'
    },
    dataFullAutobookingSupport: {
      type: String,
      default: ''
    },
    dataMechanicMeta: {
      type: String,
      default: ''
    },
    dataServiceMeta: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      slotsSelected: [] as Slot[],
      slots: null as CalendarDay[] | null,
      mounted: false as boolean
    };
  },
  computed: {
    slotSelected(): string {
      return this.slotsSelected.length ? this.slotsSelected[0].fullDate : '';
    },
    dateFrom(): string {
      return getDateFrom(0);
    },
    dateTo(): string {
      return getDateFrom(13);
    },
    calendarArray(): CalendarDay[] {
      return this.slots || [];
    },
    mechanicMeta(): IMechanicMeta {
      return JSON.parse(this.dataMechanicMeta);
    },
    serviceMeta(): IServiceMeta {
      return JSON.parse(this.dataServiceMeta);
    },
    redirect(): string {
      return bookowarkaURL + '/flow/' + (this.dataServiceCategoryUuid === 'dbb83bd4-e475-499a-9f9a-79a74654b7c5' ? '9f7b50c5-791c-4e64-a661-4ac789f1b1ac' : '473f9363-aeac-4f3f-8fed-e772574124bf');
    }

  },
  watch: {
    dataSlotsInjected() {
      if (this.dataSlotsInjected) {
        this.slots = mapCalendarSlots(JSON.parse(atob(this.dataSlotsInjected)));
      }
    }
  },

  mounted() {
    this.markNonMasterCategoryComponents();
    this.mounted = true;
    if (this.dataSharedSlots) {
      this.dataSlotsInterval ? this.pricingGetSlotsInterval() : this.pricingGetSlots();
    } else {
      this.dataSlotsInterval ? this.GETslotsInterval() : this.GETslots();
    }
  },
  methods: {
    async GETslots(): Promise<any> {
      const { data } = await HTTP(
        `/api_autobooking/slots/serviceUuid:${this.dataServiceUuid}/mechanicId:${this.dataMechanicId}/from:${getDateFrom(0)}/to:${getDateFrom(13)}.json`
      );
      this.slots = mapCalendarSlots(data);

      return data;
    },

    GETslotsInterval() {
      this.GETslots();
      setInterval(() => this.GETslots(), this.dataSlotsInterval);
    },

    async pricingGetSlots(): Promise<void> {
      if (!this.dataNonMaster) {
        const data = await this.GETslots();

        Array.from(document.getElementsByTagName('listing-calendar'))
          .filter(el => {
            return parseInt(el.getAttribute('data-mechanic-id') || '0') === this.dataMechanicId && el.getAttribute('data-service-category-uuid') === this.dataServiceCategoryUuid;
          })
          .forEach(component => {
            component.setAttribute('data-slots-injected', btoa(JSON.stringify(data)));
          });
      }
    },

    pricingGetSlotsInterval() {
      this.pricingGetSlots();
      setInterval(() => this.pricingGetSlots(), this.dataSlotsInterval);
    },

    onSlotChange(ev: Slot): void {
      this.slotsSelected = [ev];

      // submit form
      this.$nextTick(() => {
        (this.$refs.listingCalendarForm as HTMLFormElement).submit();
      });
    },

    markNonMasterCategoryComponents() {
      Array.from(document.getElementsByTagName('listing-calendar'))
        .filter(e => parseInt(e.getAttribute('data-mechanic-id') || '0') === this.dataMechanicId && e.getAttribute('data-service-category-uuid') === this.dataServiceCategoryUuid)
        .forEach((el, index) => {
          if (index > 0) {
            el.setAttribute('data-non-master', 'non-master');
          }
        });
    }
  }
});
